import { TAB_TITEL } from './TabLeiste';
import type { TabId } from './TabLeiste';
import type { Phase } from '../directus/typen';

/**
 * Kurzer Kopf ueber jedem Bereich: Kicker, Bereichstitel, und - sofern
 * bekannt - die laufende Phase als Plakette. Ersetzt seit dem Redesign die
 * fruehere Kopfzeile mit Datum, Schulwoche und Rollenanzeige; die App hat
 * seither nur noch eine Ansicht "Lehrkraft", siehe README.
 */
export function Kopfzeile({ tab, phase }: { tab: TabId; phase: Phase | null }) {
  return (
    <div className="px-5 pt-6 pb-3">
      <div className="text-xs font-semibold tracking-wide text-marke-grau uppercase">
        Abschlussjahrgänge 9/10
      </div>
      <div className="mt-0.5 flex items-baseline justify-between gap-3">
        <h1 className="text-2xl font-bold text-marke-tinte">{TAB_TITEL[tab]}</h1>
        {phase !== null && (
          <span className="shrink-0 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-marke-grau">
            Phase {phase.nummer}
          </span>
        )}
      </div>
    </div>
  );
}
